import React from 'react'

const LetterAvatar = ({ letter, size = '40px', className = '', bgColor = 'bg-primary-500', textColor = 'text-white' }) => {
    const displayLetter = letter ? letter.toString().charAt(0).toUpperCase() : '?'

    const getBackgroundColor = () => {
        if (bgColor) return bgColor

        const colors = [
            'bg-primary-500',
            'bg-success-500',
            'bg-warning-500',
            'bg-danger-500',
            'bg-info-500',
            'bg-lilac-500',
            'bg-cyan-500',
            'bg-purple-500'
        ]

        const index = displayLetter.charCodeAt(0) % colors.length
        return colors[index]
    }

    return (
        <div
            className={`${getBackgroundColor()} ${textColor} rounded-circle d-flex align-items-center justify-content-center fw-bold ${className}`}
            style={{
                width: size,
                height: size,
                fontSize: `calc(${size} * 0.4)`,
                minWidth: size,
                minHeight: size
            }}
            title={displayLetter}
        >
            {displayLetter}
        </div>
    )
}

export default LetterAvatar 